import React from 'react'
export default (self) => [
  {
    name: 'moduleName',
    title: '二级目录',
    dataIndex: 'moduleName',
    tableItem: {
      width: '12%',
      render: (value, row, index) => {
        const obj = {
          children: <span dangerouslySetInnerHTML={{__html: value}}></span>,
          props: {
            rowSpan: row.rowSpans.moduleSpan,
            style : {
              fontSize: 14
            }
          },
        }
        return obj
      }
    }
  },
  {
    name: 'questionName',
    title: '三级目录',
    dataIndex: 'questionName',
    tableItem: {
      width: '12%',
      render: (value, row, index) => {
        const obj = {
          children: <span dangerouslySetInnerHTML={{__html: value}}></span>,
          props: {
            rowSpan: row.rowSpans.questionSpan,
            style : {
              fontSize: 14
            }
          },
        }
        return obj
      }
    }
  },
  {
    name: 'target',
    title: '指标',
    dataIndex: 'target',
    tableItem: {
      width: '20%',
      render: (value, row, index) => {
        const obj = {
          children: <div dangerouslySetInnerHTML={{__html: value}}></div>,
          props: {
            rowSpan: row.rowSpans.questionSpan,
            style : {
              fontSize: 14
            }
          },
        }
        return obj
      }
    }
  },
  {
    name: 'requirements',
    title: '指标要求',
    dataIndex: 'requirements',
    tableItem: {
      width: '25%',
      render: (value, row, index) => {
        const obj = {
          children: <div dangerouslySetInnerHTML={{__html: value}}></div>,
          props: {
            rowSpan: row.rowSpans.questionSpan,
            style : {
              fontSize: 14
            }
          },
        }
        return obj
      }
    }
  },
  {
    name: 'content',
    title: '失分点',
    dataIndex: 'content',
    tableItem: {
      width: '25%',
      render: (value, row, index) => {
        const obj = {
          children: <div dangerouslySetInnerHTML={{__html: value}}></div>,
          props: {
            style : {
              fontSize: 14
            }
          },
        }
        return obj
      }
    }
  },
  {
    name: 'score',
    title: '考点得分',
    dataIndex: 'score',
    tableItem: {
      width: '6%',
      render: self._renderScore
    }
  },
]
